<div class="controls-container">
    <div class="controls-header">Menu</div>
    
    <div class="controls-sub-header">Default</div>

    <div class="menu-container">    
        <div class="menu-main-row">
            <div class="menu-icon">
                <div class="amc-icon"></div>
                <div class="menu-logo">DST-SM</div>
            </div>
            <div class="menu-line-1"></div>
            <div class="menu-line-2"></div>
            <div class="menu-line-3"></div>
            <nav class="menu-items">
                <pm-menu-drop-down-button 
                    ButtonClass="main-menu-button-button"                     
                    HorizontalAlignment="Left"
                    DropDownClass="main-menu-button">
                    <div class="pm-menu-button-header main-header-padding layout-flex">Home <pm-icon-caret-down IconClass="icon-white" [style.padding-left.px]="5"></pm-icon-caret-down></div>
                </pm-menu-drop-down-button>
            </nav>
            <div class="layout-right"></div>
            <pm-menu-drop-down-button 
                ButtonClass="menu-button-button"
                HorizontalAlignment="Right">
                <div class="pm-menu-button-header" ><pm-icon-search IconClass="icon-white" IconSize="1.25"></pm-icon-search></div> 
            </pm-menu-drop-down-button>
            <pm-button 
                ButtonClass="menu-button-button">
                <div class="pm-menu-button-header"><pm-icon-bell IconClass="icon-white" IconSize="1.25"></pm-icon-bell></div>
            </pm-button>
            <pm-menu-drop-down-button 
                ButtonClass="menu-button-button"
                HorizontalAlignment="Right">
                <div class="pm-menu-button-header"><pm-icon-user-circle IconClass="icon-white" IconSize="1.25"></pm-icon-user-circle></div>
            </pm-menu-drop-down-button>
            <pm-button 
                ButtonClass="menu-button-button">
                <div class="pm-menu-button-header"><pm-icon-question-circle IconClass="icon-white" IconSize="1.25"></pm-icon-question-circle></div>
            </pm-button>
            <div class="menu-date">
                <div class="menu-header-white">Sensitive But Unclassified</div>            
            </div>
        </div>
    
        <div class="menu-sub-row">
            <div [style.margin-left.px]="4" class="menu-status-bar-buttons">
                <pm-button 
                    ButtonClass="menu-toolbar-button">
                    <div class="pm-menu-button-header"><pm-icon-mail-forward IconClass="icon-white"></pm-icon-mail-forward></div>
                </pm-button>
                <pm-button 
                    ButtonClass="menu-toolbar-button">
                    <div class="pm-menu-button-header"><pm-icon-refresh IconClass="icon-white"></pm-icon-refresh></div>
                </pm-button>
            </div>
            <div class="menu-status-bar">
                <pm-icon-filter [style.padding-left.px]="4" IconClass="icon-gray"></pm-icon-filter>
                <div
                    style="margin-right: 4px; margin-left: 4px; display: flex; align-items: center;"
                    [style.height.px]="24"
                    class="layout-overlap menu-filter-status">Filter</div>
            </div>
            <div class="layout-flex layout-right">
                <div class="menu-sub-header-white">Time: {{DateTimeNow}} |</div>
                <div class="menu-sub-header-white " [style.padding-right.px]="1">
                    v 1.0.1
    
                    <pm-menu-drop-down-button 
                        ButtonClass="menu-toolbar-button"
                        HorizontalAlignment="Right"
                        ContainerClass="menu-button-container">
                        <div class="pm-menu-button-header">
                            <pm-icon-info-circle
                                [style.padding-left.px]="1"
                                IconClass="icon-white"
                                IconSize="1">
                            </pm-icon-info-circle>
                        </div>
                        <div class="pm-menu-button-drop-down">
                            <pm-card CardClass="info-icon-message-background" WidthPx="175">
                                <div card-header class="info-icon-message-header">
                                    Data Import Status
                                </div>
                                <div card-body class="card-body" style="color:black">
                                        <div>The most recent update of data</div>
                                        <div>from LIW to DST-SM occurred on:</div>
                                        <div class="info-icon-message-date">Testing.</div>
                                        <div>DST-SM materiel quantities</div>
                                        <div>reflect data as of this date.</div>
                                </div>
                            </pm-card>
                        </div>
                    </pm-menu-drop-down-button>
                </div>
            </div>
        </div>
    </div>

    <div class="controls-sub-header">Theme 1</div>

    <div class="menu-container-theme-2">    
        <div class="menu-main-row">
            <div class="menu-icon">
                <div class="amc-icon"></div>
                <div class="menu-logo">DST-SM</div>
            </div>
            <div class="menu-line-4"></div>
            <div class="menu-line-5"></div>
            <div class="menu-line-6"></div>
            <nav class="menu-items">
                <pm-menu-drop-down-button 
                    ButtonClass="main-menu-button-button"                     
                    HorizontalAlignment="Left"
                    DropDownClass="main-menu-button">
                    <div class="pm-menu-button-header main-header-padding layout-flex">Home <pm-icon-caret-down IconClass="icon-white" [style.padding-left.px]="5"></pm-icon-caret-down></div>
                </pm-menu-drop-down-button>
            </nav>
            <div class="layout-right"></div>
            <pm-menu-drop-down-button 
                ButtonClass="menu-button-button"
                HorizontalAlignment="Right">
                <div class="pm-menu-button-header" ><pm-icon-search IconClass="icon-white" IconSize="1.25"></pm-icon-search></div> 
            </pm-menu-drop-down-button>
            <pm-button 
                ButtonClass="menu-button-button">
                <div class="pm-menu-button-header"><pm-icon-bell IconClass="icon-white" IconSize="1.25"></pm-icon-bell></div>
            </pm-button>
            <pm-menu-drop-down-button 
                ButtonClass="menu-button-button"
                HorizontalAlignment="Right">
                <div class="pm-menu-button-header"><pm-icon-user-circle IconClass="icon-white" IconSize="1.25"></pm-icon-user-circle></div>
            </pm-menu-drop-down-button>
            <pm-button 
                ButtonClass="menu-button-button">
                <div class="pm-menu-button-header"><pm-icon-question-circle IconClass="icon-white" IconSize="1.25"></pm-icon-question-circle></div>
            </pm-button>
            <div class="menu-date">
                <div class="menu-header-white">Sensitive But Unclassified</div>            
            </div>
        </div>
    
        <div class="menu-sub-row">
            <div [style.margin-left.px]="4" class="menu-status-bar-buttons">
                <pm-button 
                    ButtonClass="menu-toolbar-button">
                    <div class="pm-menu-button-header"><pm-icon-mail-forward IconClass="icon-white"></pm-icon-mail-forward></div>
                </pm-button>
                <pm-button 
                    ButtonClass="menu-toolbar-button">
                    <div class="pm-menu-button-header"><pm-icon-refresh IconClass="icon-white"></pm-icon-refresh></div>
                </pm-button>
            </div>
            <div class="menu-status-bar">
                <pm-icon-filter [style.padding-left.px]="4" IconClass="icon-gray"></pm-icon-filter>
                <div
                    style="margin-right: 4px; margin-left: 4px; display: flex; align-items: center;"
                    [style.height.px]="24"
                    class="layout-overlap menu-filter-status">Filter</div>
            </div>
            <div class="layout-flex layout-right">
                <div class="menu-sub-header-white">Time: {{DateTimeNow}} |</div>
                <div class="menu-sub-header-white " [style.padding-right.px]="1">
                    v 1.0.1
    
                    <pm-menu-drop-down-button 
                        ButtonClass="menu-toolbar-button"
                        HorizontalAlignment="Right"
                        ContainerClass="menu-button-container">
                        <div class="pm-menu-button-header">
                            <pm-icon-info-circle
                                [style.padding-left.px]="1"
                                IconClass="icon-white"
                                IconSize="1">
                            </pm-icon-info-circle>
                        </div>
                        <div class="pm-menu-button-drop-down">
                            <pm-card CardClass="info-icon-message-background" WidthPx="175">
                                <div card-header class="info-icon-message-header">
                                    Data Import Status
                                </div>
                                <div card-body class="card-body" style="color:black">
                                        <div>The most recent update of data</div>
                                        <div>from LIW to DST-SM occurred on:</div>
                                        <div class="info-icon-message-date">Testing.</div>
                                        <div>DST-SM materiel quantities</div>
                                        <div>reflect data as of this date.</div>
                                </div>
                            </pm-card>
                        </div>
                    </pm-menu-drop-down-button>
                </div>
            </div>
        </div>
    </div>

    <div class="controls-sub-header">Theme 2</div>

    <div class="menu-container-theme-3">    
        <div class="menu-main-row">
            <div class="menu-icon">
                <div class="amc-icon"></div>
                <div class="menu-logo">DST-SM</div>
            </div>
            <div class="menu-line-7"></div>
            <div class="menu-line-8"></div>
            <div class="menu-line-9"></div>
            <nav class="menu-items">
                <pm-menu-drop-down-button 
                    ButtonClass="main-menu-button-button"                     
                    HorizontalAlignment="Left"
                    DropDownClass="main-menu-button">
                    <div class="pm-menu-button-header main-header-padding layout-flex">Home <pm-icon-caret-down IconClass="icon-white" [style.padding-left.px]="5"></pm-icon-caret-down></div>
                </pm-menu-drop-down-button>
            </nav>
            <div class="layout-right"></div>
            <pm-menu-drop-down-button 
                ButtonClass="menu-button-button"
                HorizontalAlignment="Right">
                <div class="pm-menu-button-header" ><pm-icon-search IconClass="icon-white" IconSize="1.25"></pm-icon-search></div> 
            </pm-menu-drop-down-button>
            <pm-button 
                ButtonClass="menu-button-button">
                <div class="pm-menu-button-header"><pm-icon-bell IconClass="icon-white" IconSize="1.25"></pm-icon-bell></div>
            </pm-button>
            <pm-menu-drop-down-button 
                ButtonClass="menu-button-button"
                HorizontalAlignment="Right">
                <div class="pm-menu-button-header"><pm-icon-user-circle IconClass="icon-white" IconSize="1.25"></pm-icon-user-circle></div>
            </pm-menu-drop-down-button>
            <pm-button 
                ButtonClass="menu-button-button">
                <div class="pm-menu-button-header"><pm-icon-question-circle IconClass="icon-white" IconSize="1.25"></pm-icon-question-circle></div>
            </pm-button>
            <div class="menu-date">
                <div class="menu-header-white">Sensitive But Unclassified</div>            
            </div>
        </div>
    
        <div class="menu-sub-row">
            <div [style.margin-left.px]="4" class="menu-status-bar-buttons">
                <pm-button 
                    ButtonClass="menu-toolbar-button">
                    <div class="pm-menu-button-header"><pm-icon-mail-forward IconClass="icon-white"></pm-icon-mail-forward></div>
                </pm-button>
                <pm-button 
                    ButtonClass="menu-toolbar-button">
                    <div class="pm-menu-button-header"><pm-icon-refresh IconClass="icon-white"></pm-icon-refresh></div>
                </pm-button>
            </div>
            <div class="menu-status-bar">
                <pm-icon-filter [style.padding-left.px]="4" IconClass="icon-gray"></pm-icon-filter>
                <div
                    style="margin-right: 4px; margin-left: 4px; display: flex; align-items: center;"
                    [style.height.px]="24"
                    class="layout-overlap menu-filter-status">Filter</div>
            </div>
            <div class="layout-flex layout-right">
                <div class="menu-sub-header-white">Time: {{DateTimeNow}} |</div>
                <div class="menu-sub-header-white " [style.padding-right.px]="1">
                    v 1.0.1
    
                    <pm-menu-drop-down-button 
                        ButtonClass="menu-toolbar-button"
                        HorizontalAlignment="Right"
                        ContainerClass="menu-button-container">
                        <div class="pm-menu-button-header">
                            <pm-icon-info-circle
                                [style.padding-left.px]="1"
                                IconClass="icon-white"
                                IconSize="1">
                            </pm-icon-info-circle>
                        </div>
                        <div class="pm-menu-button-drop-down">
                            <pm-card CardClass="info-icon-message-background" WidthPx="175">
                                <div card-header class="info-icon-message-header">
                                    Data Import Status
                                </div>
                                <div card-body class="card-body" style="color:black">
                                        <div>The most recent update of data</div>
                                        <div>from LIW to DST-SM occurred on:</div>
                                        <div class="info-icon-message-date">Testing.</div>
                                        <div>DST-SM materiel quantities</div>
                                        <div>reflect data as of this date.</div>
                                </div>
                            </pm-card>
                        </div>
                    </pm-menu-drop-down-button>
                </div>
            </div>
        </div>
    </div>

</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/menu/menu.html